
<div mat-dialog-content>
<div class="customModal"role="dialog">
  <div class="modal-header">
    <h2 class="mb-0">Warning</h2>
  </div>
  <div class="modal-body">
    <p>The profile has been updated. Some of the settings or profile information might not reflect correctly.
      We recommend logging out and logging back in. Please confirm your action.</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onLogout()">Logout</button>
    <button mat-button (click)="onContinue()">Continue</button>
  </div>
</div>
</div>
